<template>
  <crud-modal
    :title="$t('components.modals.company.exportImplementation.title')"
    action="export"
    :on-submit="submit"
    :on-close="() => $emit('close')"
  >
    <p>{{ $t('components.modals.company.exportImplementation.description') }}</p>
  </crud-modal>
</template>

<script>
import CrudModal from '@/components/modals/crud-modal'
import { exportImplementationData } from '@/lib/export'

export default {
  components: {
    CrudModal
  },
  props: {
    companyId: {
      type: String,
      required: true
    }
  },

  methods: {
    async submit () {
      await exportImplementationData(this.companyId)
    }
  }
}
</script>
